import _ from 'lodash';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { Grid, Form } from 'semantic-ui-react';
import { Field, reduxForm, getFormValues, change } from 'redux-form';

import { TitledCard } from 'Components';
import { ReportFieldEnum } from 'Common/FieldEnum';
import { SiteComponent } from 'Common/SiteComponent';
import { TEACHER_ROLLS_FORM_NAME } from 'Common/FormEnum';
import { ReportFieldEnum as Fields } from 'Common/FieldEnum';
import { SelectField, CheckboxField } from 'Common/SemanticWrapper';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { YesNoOptions } from 'Common/FormHelper';

class TeacherRollsForm extends Component {
  state = {
    teachers: [],
    teachersOptions: [],
    gradeOptions: [],
    siteData: '',
  };

  numberOptions = [
    { value: true, label: 'Serving Number' },
    { value: false, label: 'Student Number' },
  ];

  dropDownChange = (data) => {
    if (this.state.siteData !== data) {
      this.props.change(`${ReportFieldEnum.Teacher}`, 'ALL');
      this.props.change(`${ReportFieldEnum.Grade}`, 'ALL');
      this.props.siteChange(data);
      this.setState({ siteData: data });
    }
  };
  componentWillReceiveProps(nextProps) {
    if (this.state.teachers !== nextProps.teachers) {
      let teachersOptions = [];
      let gradeOptions = [];
      gradeOptions = [{ value: 'ALL', text: 'ALL', key: 'valueALL' }];
      teachersOptions = [{ value: 'ALL', text: 'ALL', key: 'valueALL' }];
      if (nextProps.teachers.length > 0) {
        let uniqueTeachers = _.sortBy(
          _.uniqBy(nextProps.teachers, 'Teacher'),
          'Teacher'
        );
        teachersOptions.push({
          value: 'unassigned',
          text: 'UNASSIGNED',
          key: 'unassignedValue',
        });
        uniqueTeachers.map((teacher, i) => {
          teacher.Teacher &&
            teachersOptions.push({
              value: teacher.Teacher,
              key: i,
              text: teacher.Teacher,
            });
          return null;
        });
        let grades = _.sortBy(
          _.uniqBy(nextProps.teachers, 'GradeId'),
          'GradeId'
        );
        grades.map((grade, i) => {
          gradeOptions.push({
            value: grade.GradeId,
            key: i,
            text: grade.GradeId + ' ' + grade.GradeDescription,
          });
          return null;
        });
      }
      this.setState({
        teachersOptions: teachersOptions,
        gradeOptions: gradeOptions,
        teachers: nextProps.teachers,
      });
    }
  }
  render() {
    const { loading, disabled, formValues } = this.props;

    return (
      <Form>
        <TitledCard title={'Report Parameters'}>
          <Grid columns={2} style={{ paddingBottom: '10px' }}>
            <Grid.Row>
              <Grid.Column>
                <SiteComponent
                  name={ReportFieldEnum.Site}
                  onChange={this.dropDownChange}
                  {...this.props}
                  isForm={true}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  name={ReportFieldEnum.Teacher}
                  component={SelectField}
                  type="text"
                  label="Teacher"
                  options={this.state.teachersOptions}
                  loading={loading}
                  disabled={disabled}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  name={ReportFieldEnum.Grade}
                  component={SelectField}
                  type="text"
                  label="Grade"
                  options={this.state.gradeOptions}
                  loading={loading}
                  disabled={disabled}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ marginLeft: '16px' }}>
              <div className="ui form field">
                <label>Display on Report?</label>
              </div>
            </Grid.Row>
            <Grid.Row columns={4}>
              <Grid.Column>
                <Field
                  name={ReportFieldEnum.Balance}
                  label="Balance"
                  component={CheckboxField}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  name={ReportFieldEnum.BarCodes}
                  label="Bar Codes"
                  component={CheckboxField}
                />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row columns={4}>
              <Grid.Column>
                <Field
                  name={ReportFieldEnum.Allergen}
                  label="Allergies"
                  component={CheckboxField}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  name={ReportFieldEnum.Status}
                  label="Status"
                  component={CheckboxField}
                />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column>
                <ReduxFormButtonGroup
                  label={'Student Number or Serving Number'}
                  options={this.numberOptions}
                  disabled={loading}
                  formName={TEACHER_ROLLS_FORM_NAME}
                  fieldName={Fields.UseServingNumber}
                  value={
                    formValues ? formValues[Fields.UseServingNumber] : true
                  }
                />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={6}>
                <ReduxFormButtonGroup
                  label="Include Non LEA Students"
                  formName={TEACHER_ROLLS_FORM_NAME}
                  fieldName={Fields.IncludeNonLeaStudents}
                  options={YesNoOptions}
                  disabled={loading}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
      </Form>
    );
  }
}

const formValuesSelector = getFormValues(TEACHER_ROLLS_FORM_NAME);

const mapStateToProps = (state) => {
  return {
    formValues: formValuesSelector(state),
  };
};

const mapDispatchToProps = {
  change,
};

TeacherRollsForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(TeacherRollsForm);

const validate = (values) => {
  const errors = {};
  if (!values[ReportFieldEnum.Site]) {
    errors[ReportFieldEnum.Site] = 'Site is required';
  }
  if (!values[ReportFieldEnum.Teacher]) {
    errors[ReportFieldEnum.Teacher] = 'Teacher is required';
  }
  if (!values[ReportFieldEnum.Grade]) {
    errors[ReportFieldEnum.Grade] = 'Grade is required';
  }
  return errors;
};

export default reduxForm({
  validate,
  form: TEACHER_ROLLS_FORM_NAME,
})(TeacherRollsForm);



// WEBPACK FOOTER //
// ./src/pages/teacherrolls/components/TeacherRollsForm.js